export default "__VITE_ASSET__DDn2jM3n__"